import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export const BackToTop = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="back-to-top-button"
      aria-label="Volver arriba"
      className="fixed bottom-6 right-6 z-40 w-12 h-12 rounded-full bg-[#0066FF] hover:bg-[#0052CC] text-white flex items-center justify-center shadow-xl shadow-[#0066FF]/40 transition-all hover:-translate-y-1"
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
};

export default BackToTop;
